import React from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import MovementsList from 'application/movements/MovementsList'
import AddMovement from 'application/movements/AddMovement'
import FundsList from 'application/funds/FundsList'
import ImportStatement from 'application/movements/ImportStatement'
import Settings from 'application/user/Settings'
import Report from 'application/budget/report/Report'
import Plan from "application/budget/plan/Plan"
import qs from 'qs'
import ClassificationRulesList from './categories/ClassificationRulesList'
import AddClassificationRule from './categories/AddClassificationRule'
import EditClassificationRuleScreen from './categories/EditClassificationRuleScreen'
import Trends from './budget/trends/Trends'
import UsersAdmin from './admin/UsersAdmin'
import CurrenciesAdmin from './admin/CurrenciesAdmin'
import SqlAdmin from './admin/SqlAdmin'
import TagsList from 'application/tags/TagsList'
import AssetPortfolio from './investments/AssetPortfolio'
import AssetTransactionsList from './investments/AssetTransactionsList'
import AssetPoolDetails from './investments/AssetPoolDetails'
import ImportAssetTransactions from './investments/ImportAssetTransactions'
import ImportAssetNames from './investments/ImportAssetNames'

function useQuery(): Record<string, string> {
    return qs.parse(useLocation().search.substr(1)) as Record<string, string>
}

export default function Home() {
    const query = useQuery()
    return (
        <Routes>
            <Route path="/" element={<Report query={query} url="/report" />} />
            <Route path="/movements/import" element={<ImportStatement />} />
            <Route path="/movements/add" element={<AddMovement />} />
            <Route path="/movements" element={<MovementsList query={query} url="/movements" />} />
            <Route path="/funds" element={<FundsList />} />
            <Route path="/tags" element={<TagsList />} />
            <Route path="/report" element={<Report query={query} url="/report" />} />
            <Route path="/plan" element={<Plan query={query} url="/plan" />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/classification-rules/add" element={<AddClassificationRule />} />
            <Route path="/classification-rules/:id/edit" element={<EditClassificationRuleScreen />} />
            <Route path="/classification-rules" element={<ClassificationRulesList query={query} url="/classification-rules" />} />
            <Route path="/trend" element={<Trends />} />
            <Route path="/admin/sql" element={<SqlAdmin />} />
            <Route path="/admin/users" element={<UsersAdmin />} />
            <Route path="/admin/currencies" element={<CurrenciesAdmin />} />
            <Route path="/investments/assets/import" element={<ImportAssetNames />} />
            <Route path="/investments/assets/:id" element={<AssetPoolDetails />} />
            <Route path="/investments/assets" element={<AssetPortfolio />} />
            <Route path="/investments/transactions/import" element={<ImportAssetTransactions />} />
            <Route path="/investments/transactions" element={<AssetTransactionsList />} />
            <Route path="*" element={<h1>Not found!</h1>} />
        </Routes>
    )
}
